// extracted by mini-css-extract-plugin
export default {"container":"DetailsReserve_container__hDuT3","containerCart":"DetailsReserve_containerCart__lEman"};